import { gql } from "@apollo/client";

export const GetClientPage = gql`
  query GetClientPage($pagination: PaginationInput!) {
    clientPage(pagination: $pagination) {
      items {
        id
        user {
          id
          firstName
          lastName
          email
          createdDate
          profilePicUrl
        }
      }
      totalRows
    }
  }
`;

export const GetClient = gql`
  query GetClient($id: String) {
    clientOne(id: $id) {
      id
      dob
      memberStatus
      memberCode
      homePhone
      workPhone
      address
      city
      state
      zipCode
      country
      idNumber
      employer
      gender
      emergencyName
      emergencyPhone
      relationship
      attendee {
        id
      }
      preferences {
        minimumNotice
        notificationType
      }
      user {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
        createdDate
        smsConsent
        profilePicUrl
        role
        acceptedTAC
        lastLoginAt
        username
      }
      notes {
        id
        content
        isMigrated
        author {
          id
          user {
            id
            firstName
            lastName
            profilePicUrl
          }
        }
        updatedDate
      }
      organization {
        id
        name
        logoUrl
        organizationBranding {
          primaryColor
          secondaryColor
          id
          brandingLogoImg
        }
      }
      paymentMethods {
        id
        name
        mask
        vendor
        expiresAt
        merchant
        isPrimary
        isComplete
      }
      groups {
        id
        name
        clientGroupType
        clients {
          id
          user {
            firstName
            lastName
          }
        }
      }
      locations {
        address
        city
        name
        state
        zip
        id
      }
      defaultLocation {
        id
        name
      }
    }
  }
`;

export const GetClientGroupMany = gql`
  query GetClientGroupMany($id: String) {
    clientGroupMany(id: $id) {
      id
      name
      clientGroupType
      primaryClient {
        id
        user {
          id
          firstName
          lastName
        }
      }
      clients {
        id
        user {
          firstName
          lastName
        }
      }
      signedAgreement {
        agreement {
          id
          name
          description
        }
      }
    }
  }
`;

export const GetClientGroupPage = gql`
  query GetClientGroupPage($pagination: PaginationInput!) {
    clientGroupPage(pagination: $pagination) {
      items {
        id
        name
      }
      totalRows
    }
  }
`;

export const GetClientCheckInPage = gql`
  query GetClientCheckInPage($pagination: PaginationInput!) {
    clientPage(pagination: $pagination) {
      items {
        id
        user {
          firstName
          lastName
          profilePicUrl
        }
        memberStatus
        leadStatus
      }
      totalRows
    }
  }
`;

export const GetClientGuestLead = gql`
  query GetClientGuestLead($id: String!) {
    clientOne(id: $id) {
      id
      dob
      homePhone
      workPhone
      address
      city
      state
      zipCode
      country
      idNumber
      employer
      gender
      emergencyName
      emergencyPhone
      relationship
      user {
        id
        email
        firstName
        lastName
        profilePicUrl
        username
      }
      notes {
        id
        content
        isMigrated
        author {
          id
          user {
            id
            firstName
            lastName
            profilePicUrl
          }
        }
        updatedDate
      }
    }
  }
`;

export const GetSuggestedUserName = gql`
  query GetSuggestedUserName($firstName: String!, $lastName: String!) {
    suggestedUserName(firstName: $firstName, lastName: $lastName)
  }
`;

export const clientSampleCSV = gql`
  query clientSampleCSV {
    clientSampleCSV
  }
`;

export const GetAccountDetailReport = gql`
  query GetAccountDetailReport($data: AccountReportInput!) {
    accountDetailReport(data: $data) {
      id
      locations {
        id
        name
      }
      agreements {
        id
        subscription {
          isActive
        }
      }
      memberStatus
      preferences {
        notificationType
      }
      standing
      user {
        firstName
        lastName
        email
        phoneNumber
      }
      city
      country
      dob
      idNumber
      leadStatus
      state
      employer
      gender
      zipCode
      address
    }
  }
`;

export const DownloadAccountDetailReport = gql`
  query DownloadAccountDetailReport($data: AccountReportInput!) {
    downloadAccountDetailReport(data: $data)
  }
`;
